<template>
    <div class="bg th ba b--light-gray" :style="backgroundStyle">        
        <select class="pointer" :style="selectStyle" :value="value" @input="$emit('input', $event.target.value)">
            <slot></slot>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        imageUrl: {
            type: String
        },
        value: { type: String }
    },
    computed: {
        backgroundStyle() {
            return this.imageUrl
                ? { 'background-image': `url(${this.imageUrl})` }
                : null;
        },
        selectStyle() {
            return this.imageUrl
                ? { 'padding-left': '40px' }
                : { 'padding-left': '10px' };
        }
    }
};
</script>

<style scoped>
.bg {
    background-repeat: no-repeat;
    background-position: 10px center;
}

select {
    width: 100%;
    height: 100%;
    border: none;
    box-shadow: none;
    background: transparent;
    background-image: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

select:focus {
    outline: none;
}

select::-ms-expand {
    display: none; /* hide the default arrow in ie10 and ie11 */
}
</style>
